import { Tracking } from '@gjensidige/core-analytics';
import { triggerHotjarCurrentView } from './utils/hotjar-helpers';
export const tracker = new Tracking({
    application_name: 'gpf-fkl',
    application_partner: 'gjensidige',
    customer_segment: 'privat',
    business_area: 'pensjon',
    application_module: 'spareavtale',
    scenario_name: 'bestill-fkl',
    scenario_step: 'bestill-fkl',
});
export const trackScenario = (step) => {
    triggerHotjarCurrentView('gpf_fkl', step);
    tracker.setOptions({ scenario_step: step });
    tracker.trackView();
};
export const scenarioSteps = {
    LOGG_INN_BANKID: 'Logg inn med BankID',
    KONTOOPPLYSNINGER: 'Spareformål og kontonavn',
    AMOUNT: 'Velg sparebeløp',
    RAADGIVNING_EGNETHET: 'Rådgivning, risiko og egnethet',
    RAADGIVNING_EGNETHET_RESULTAT: 'Rådgivning, anbefaling',
    RAADGIVNING_FATCA: 'Fatca, pep og hvitvasking',
    FUND_PROFILE: 'Velg profil',
    SUMMARY: 'Oppsummering av avtale',
    ABOUT: 'Om deg',
    SIGNING: 'Signering',
    SIGNING_COMPLETE: 'Signert avtale',
    AVTALEGIRO_SIGNING_COMPLETE: 'Signert avtalegiro',
};
